import React from 'react'
// libs
import { FieldArray } from 'redux-form'
// views
import { LevelContainer } from 'components/PageComponents/Settings/PlanTypes/Edit/Form/views'
// components
import { ReduxInput } from 'components/FormElements'
// view components
import LevelOptions from 'components/PageComponents/Settings/PlanTypes/Edit/Form/components/LevelOptions'
import ColorPanel from 'components/PageComponents/Settings/PlanTypes/Edit/Form/components/ColorPanel'
// utils
import { required } from 'utils/validators'

const Levels = ({ fields, onPanelClick }) => {
  return fields.map((field, index) => {
    const { color } = fields.get(index)

    const label = `Objective Level ${index + 1} Label`

    return (
      <div key={field}>
        <LevelContainer>
          <ReduxInput name={`${field}.description`} label={label} validate={[required]} />
          <ColorPanel name={index} color={color} onClick={onPanelClick(field, color)}>
            set objective color {color}
          </ColorPanel>
        </LevelContainer>
        <FieldArray name={`${field}.typeOptions`} label={label} component={LevelOptions} />
      </div>
    )
  })
}

export default Levels
